/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:41:28
 */
import zhLocale from 'element-ui/lib/locale/lang/zh-TW'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "AI 報告剖析",
        train: "訓練大綱",
        loading: "載入中...",
        loadingError1: "載入失敗",
        loadingError2: "抱歉，請稍後再試。",
    },
    // 登录页面
    login: {
        loginAndRegister: '註冊/登錄',
        registerAndLogin: '登錄/註冊',
        userLogin: '用戶登錄',
        title: '手機帳號和郵箱帳號互相獨立，請注意您的帳號類型。',
        mobileLogin: '手機',
        emailLogin: '郵箱',
        email: 'E-mail',
        loginBtn: '登錄',
        autoLogin: '下次自動登錄',
        retransmission: '{item}秒後重發',
        formList: [
            {
                label: '請輸入手機號碼',
                placeholder: '獲取驗證碼',
            },
            {
                label: '驗證碼',
                placeholder: '請輸入驗證碼',
            },
            {
                label: '請輸入郵箱',
            },
        ],
        btn: {
            submit: '創建新帳號',
            title: '真實的資訊非常重要，請仔細填寫',
        },
        rule: {
            phone: {
                requiredMsg: '手機號格式不正確',
                patternMsg: '手機號未註冊，請創建新帳號',
            },
            authCode: {
                requiredMsg: '驗證碼錯誤，請重新填寫',
            },
            email: {
                requiredMsg: '郵箱格式不正確',
                patternMsg: '郵箱未註冊，請創建新帳號',
            },
        },
        codeSuccess: '驗證碼已發送，請查收',
        success: '發送成功',
        error: '發送失敗',
        loginSuccess: '登錄成功',
        account: {
            accountTitle: '登錄',
            registerTitle: '註冊',
            resetTitle: '設定密碼',
            password: '密碼',
            placeholder: '請輸入密碼',
            codeLogin: '驗證碼登入',
            accountLogin: '使用密碼登入',
            forgotPassword: '忘記密碼？',
            registerTips:[
                '還沒有帳號？', 
                '註冊', 
                '帳號已存在',
                '立即註冊',
            ],
            checkRule: [
                '8-20 個字元',
                '至少包含一個大寫字母',
                '至少包含一個小寫字母',
                '至少包含一個數字', 
                '密碼不一致'
            ],
            errorTips: [
                '密碼錯誤', 
                '登入失敗', 
                '帳號不存在'
            ],
            reset:[
                '重設密碼', 
                "下一步",
                '新密碼不能與上一次的密碼相同', 
                '跳過',
                '密碼設定成功'
            ],
            setPasswordTips:'密碼需由 8 至 20 個字元組成，且必須包含大寫字母、小寫字母與數字。',
            confirmPassword: "確認密碼",
        },
        switchButton: '密碼登入',
        switchButton1: '驗證碼登入',
        loginTips: '未註冊的帳號登入成功將自動註冊',
        otherLogin: '其他登入方式',
        newEmailLogin: '郵箱登陸',
        newPhoneLogin: '手機號登陸',
        bindLineTips:'或',
        bindEmail: '綁定電子郵件登入',
        bindPhone: '綁定手機號碼登入',
        bindAndContinue: "綁定並繼續",
        bind: "綁定",
        bindEmailTitle: '綁定郵箱',
        bindEmailTips1: "未獲取到您的 {item} 郵箱資訊",
        bindEmailTips2: "請綁定郵箱以繼續使用帳號",
        bindEmailTips3: "您的帳號尚未綁定郵箱，綁定後可透過郵箱登錄並找回密碼",
        boundTitle: '您之前是否註冊過？',
        boundCenterTitle1:'如果您是新用戶',
        boundCenterTips1:'可以直接創建帳號並開始使用',
        boundCenterTitle2:'如果您之前註冊過帳號',
        boundCenterTips2:'可以綁定已有帳號以同步歷史數據',
        boundCenterTips3:'請綁定已註冊的帳號',
        boundCenterTips4:'推薦',
        boundCenterTips5:'將 {item} 帳號綁定到已有帳號',
        boundCenterTips6:'綁定後，歷史測量數據和報告會自動同步',
        boundButton1: '使用 {item} 創建帳號',
        boundButton2: '綁定已有帳號',
        phoneCode:"手機驗證碼登錄",
        phonePassword:"手機密碼登錄",
        emailCode:"郵箱驗證碼登錄",
        emailPassword:"郵箱密碼登錄",
        thirdAccountAlreadyRegistered: '該帳號已註冊，請重新登入。', // 第三方账号重复注册提示。
        accountDoesNotExist:"該帳號尚未註冊，請使用信箱驗證碼或 {item} 登入完成註冊。",
        toRegister:"去註冊",
        bindNow: "立即綁定",
        bindError:[
            '綁定失敗',
            '解除綁定成功',
            '解綁失敗',
            '授權失敗',
            '授權失敗，無法取得帳號資訊',
            '綁定成功',
            '帳號不存在，請綁定已註冊的帳號。',
            '綁定失敗，該帳號已綁定至 {item} 帳號 [{nickname}]。',
            '已授權註冊為帳號，不支援解除綁定',
            '帳號不存在，請使用驗證碼登入並註冊',
        ],
        accountSecurity: {
            faceBook:'Facebook 帳號',
            google: 'Google 帳號',
            isBind: '未綁定',
            dialogTitle: '確認解除綁定？',
            dialogCenter: '解除綁定 {item} 後將無法繼續使用它登入該帳號',
            bindFailure:'綁定失敗',
            bindFailureTips: '您的 {item} 帳號已被下方帳號綁定，如需換綁至當前帳號，請先登入下方帳號解除綁定',
            returnButton:'確認並返回'
        },
        bindEmailError: [
            "郵箱已存在，請更換郵箱。"
        ],
    },
    // 注册页面
    register: {
        mobileRegister: '手機註冊',
        emailRegister: '郵箱註冊',
        enroll: '手機號已註冊',
        enrollEmail: '郵箱已註冊',
        search: '搜索',
        title: '手機帳號和郵箱帳號互相獨立，請注意您的帳號類型。',
        needRead: {
            agree: '我已閱讀並同意',
            privacy: '《用戶隱私協議》',
        },
        register: '註冊',
        check: '勾選“用戶隱私協議”',
        newUser: '新用戶註冊',
        form: {
            labelList: ['姓名', '* 性别', '* 身高', '* 年齡'],
        },
        placeholder: ['請輸入姓名', '請輸入你的身高', '請輸入你的年齡'],
        unit: ['公制', '英制', '歲'],
        sexOptions: {
            male: '男',
            female: '女',
        },
        btn: '提交',
        rules: {
            metricheight: ['允許測量的身高範圍是 2ft3in-6ft7in，請重新輸入'],
            heightMsg: ['允許測量的身高範圍是 70-200cm，請重新輸入'],
            ageMsg: ['允許測量的年齡範圍 10-99歲，請重新輸入'],
            agePointMsg: ['填寫了非整數：年齡只能為整數，請填寫正確的年齡'],
        },
        success: '註冊成功',
        userMessage: '請輸入用戶名',
        verify: '請輸入4位數的驗證碼',
        errorMsg: '允許輸入的身高格式不支持小數，請重新輸入',
        abnormalMsg: '註冊異常',
    },
    // 模型合成
    model: {
        loading: '模型生成中，請您稍候',
        modelLoading: '模型加載中...',
        tabPane: [
            {
                title: '深度實感技術',
                msg: '通過三維掃描準確採集身體局部細節，保證圍度測量的毫米級精度，讓健身後的體型變化清晰呈現。',
            },
            {
                title: 'BDA 體成分演算法',
                msg: '維塑採用最前沿的人體成分測算體系--BDA 演算法確定人體成分，這項基於身體體積的測算方式將更精確地評估肥胖帶來的健康風險。',
            },
            {
                title: '誤差產生因素',
                msg: '寬鬆的著裝、身上的異物等都會導致不同程度的誤差，如您想獲取最精確的數據，請您穿著緊身衣或減少身上的衣物。',
            },
            {
                title: '報告入口',
                msg: '建議收藏網頁，方便日後查看報告。稍後您也可將此報告發送至郵箱保存。',
            },
        ],
        collect: ['請收藏本網頁，', '方便日後查看報告。'],
        know: '我知道了',
        reminder: [
            '溫馨提示',
            '您的三維模型已生成，可嘗試左右滑動來旋轉模型。',
            '您的報告已生成，可點擊“查看報告”按鈕查看。',
            '您的體態評估未成功，請查看體成分報告。',
            '您的身體成分未成功，請查看體態評估報告。',
            '您的測量未成功，請到設備端重新體驗哦~',
            '身體成分未成功，請到設備端重新體驗哦~',
            '體態評估未成功，請到設備端重新體驗哦~',
        ],
        btn: {
            viewReport: '查看報告',
            bodyReport: '查看體成分報告',
            postureReport: '查看體態報告',
            lastReport: '查看上次報告',
            loading: '加載中...',
        },
    },
    // 报告
    report: {
        btn: {
            download: '下載報告',
            send: '發送報告',
            report: '報告',
        },
        reportSuccess: '報告生成成功',
        tabPane: {
            labelList: ['測量時間', '測量專案', '身體成分', '體態評估', '肩部功能'],
        },
        sendEmail: '發送至郵箱:',
        requiredMsg: '請輸入你的郵箱地址',
        patternMsg: '請輸入正確的郵箱',
        send: '發送',
        download: '下載報告',
        sendReport: '發送報告',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: '性別修改成功',
            height: '身高修改成功',
            age: '年齡修改成功',
        },
        logOut: '退出登錄',
        personal: '個人中心',
        cut: '切換單位/語言',
        changeSort: '切換產品報告',
        setPassword: '設定/修改密碼',
        accountSecurity: '帳號與安全',
        describe: '* 切換產品型號後，將為您展示對應產品型號下的所有測量報告。',
        describeBtn: '產品型號切換後，將為您跳轉到該產品型號下的最新測量報告。',
        descReport: '產品報告切換成功',
        unit: ['公制 (kg, cm)', '英制 (ft, in, lb)'],
        read: {
            reading: '閱讀',
            privacy: '《用戶隱私協議》',
        },
        setting: '設置',
        form: {
            labelList: ['手機號碼', '單位', '語言', '昵稱', '性別', '身高', '年齡'],
        },
        placeholder: ['修改昵稱', '性別修改', '身高修改', '年齡修改'],
        btn: {
            cancelBtn: '取消',
            accomplishBtn: '完成',
            confirmBtn: '確定',
        },
        dialog: [
            '性別是體成分測量的重要依據之一，修改後測量的數據會與以往數據出現差異，請確認是否修改？',
            '身高是體成分測量的重要依據之一，修改後測量的數據會與以往數據出現差異，請確認是否修改？',
            '年齡是體成分測量的重要依據之一，修改後測量的數據會與以往數據出現差異，請確認是否修改？',
        ],
        rules: {
            metricheight: ['請填寫範圍內身高（2ft3in-6ft7in）'],
            heightMsg: ['請填寫範圍內身高（70-200cm）'],
            ageMsg: ['請填寫範圍內年齡（10-99歲）', '填寫了非整數：年齡只能為整數，請填寫正確的年齡'],
        },
        heightMsg: '請重新選擇身高',
        ageMsg: '請重新選擇年齡',
        ModelBinding: '好像有人捷足先登掃碼了呢，請重新測量吧！',
        ReportEmpty: {
            title: '您還沒有相關檢測報告',
            desc: '找到 Visbody 3D 體測精靈，進行一次測量吧！',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: '好像有人捷足先登掃碼了呢，請重新測量吧！',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: '您還沒有相關檢測報告',
        desc: '找到 Visbody 3D 體測精靈，進行一次測量吧!',
        descS30: '找到 Visbody 3D 體測精靈，進行一次測量吧!',
        descM30: '找到 Visbody 3D 體測精靈，進行一次測量吧!',
    },
    // 用户信息
    userInfo: {
        height: '身高:',
        age: '年齡:',
        unit: '歲',
        weight: '體重',
    },
    // 体成分
    mass: {
        title: '體成分評估總覽',
        titles: '身體成分',
        springFrame: '',
        massFrame: '暫無當天測量測量數據',
        contrast: '選一份報告對比',
        contrastReport: '選擇一份對比報告',
        noRecord: '無記錄',
        score: '分',
        status: '您目前的體成分狀況',
        WT: '體重',
        PBF: '體脂率',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: '測量值',
            standardRange: '標準範圍',
            comparedWithLastLime: '對比上次',
            comparedNet: '對比上次',
            current: '本次测量分数',
            WT: '體重',
            FFM: '去脂體重',
            BFM: '體脂肪',
            LM: '肌肉量',
            TBW: '總水分',
            SM: '骨骼肌',
            PROTEIN: '蛋白質',
            TM: '無機鹽',
            BMR: '基礎代謝',
            WHR: '腰臀比',
            BMI: 'BMI',
            PBF: '體脂率',
            VFG: '內臟脂肪等級',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        // 定义解读
        explain: [
            {
                title: '體重',
                msg: '體重是身體水分、蛋白質、無機鹽和體脂肪的總和。',
            },
            {
                title: '去脂體重',
                msg: '去脂體重是體重扣除脂肪的部分。',
            },
            {
                title: '體脂肪',
                msg: '體脂肪是皮下脂肪，內臟脂肪和肌肉之間脂肪的總和。',
            },
            {
                title: '肌肉量',
                msg: '肌肉量是人體的瘦組織群，包括了骨骼肌、平滑肌和心肌。',
            },
            {
                title: '總水分',
                msg: '身體水分在人體成分中占的含量最多，占體重的50%~70%，身體水分分佈於人體細胞和體液中，其中大部分存在於肌肉細胞中。',
            },
            {
                title: '骨骼肌',
                msg: '骨骼肌又稱橫紋肌，附著在骨骼上的肌肉，肌肉中的一種，此處計算的是骨骼肌的含量。',
            },
            {
                title: '蛋白質',
                msg: '蛋白質是含氮的固態物質，存在於人體所有細胞內，參與細胞構成。是肌肉量的主要成分。',
            },
            {
                title: '無機鹽',
                msg: '人體是由有機物、無機物和水組成的，人體裏的無機物叫無機鹽，無機鹽大約占人體重量的5%。',
            },
            {
                title: '基礎代謝',
                msg: '基礎代謝指人體在清醒而安靜的狀況下，不受運動、食物、神經緊張、外界溫度變化等影響時一天消耗的總能量。',
            },
            {
                title: '腰臀比',
                msg: '腰臀比是腰圍和臀圍的比值，是判定中心性肥胖的重要指標。',
            },
            {
                title: 'BMI',
                msg: 'BMI主要用於評估外觀肥胖度，國際上常作為衡量人體胖瘦程度的標準。',
            },
            {
                title: '體脂率',
                msg: '體脂肪率是指體脂肪占體重的比率。',
            },
            {
                title: '內臟脂肪等級',
                msg: '內臟脂肪等級是評價是否屬於隱性肥胖的重要指標。',
            },
            {
                title: '細胞內液',
                msg: '細胞內液：是肌體細胞總體所含的體液，是原生質的基本組成部分。',
            },
            {
                title: '細胞外液',
                msg: '細胞外液：通常指為與細胞外的體液，包括血漿以及介於血管和組織細胞之間的組織間液。',
            },
            {
                title: '代謝年齡',
                msg: '代謝年齡是指身體及其健康相關的代謝功能的表現。',
            },
            {
                title: '細胞外水分比率',
                msg: '細胞外水分比率是指細胞外水分（ECW）在全身總水分（TBW）中所佔的比例，通常以 ECW/TBW 表示，是評估人體體液平衡狀態的重要指標。',
            },
        ],
        // 节段
        segment: {
            fat: '節段脂肪',
            muscle: '節段肌肉',
            right: '右',
            left: '左',
            standard: '標準',
            lowStandard: '低標準',
            superStandard: '高標準',
            peel: '(皮重)',
        },
    },
    // 体态
    shape: {
        title: '體態評估總覽',
        titles: '體態評估',
        status: '您目前的體態狀況',
        suggest: '建議',
        possibility: '，存在',
        models: {
            front: '正面',
            left: '左側面',
            right: '右側面',
            top: '背面',
            low: '偏低',
            high: '偏高',
            normal: '正常',
        },
        item: {
            deviate: '測量值',
            result: '說明',
            normal: '正常',
			keAbnormal: '可能有異常情況',
            abnormal: '異常',
            head: '頭前引',
            headSlant: '頭側歪',
            roundShoulderLeft: '左圓肩',
            roundShoulderRight: '右圓肩',
            highLowShoudler: '高低肩',
            pelvis: '骨盆前/後移',
            leftKneeCheck: '左膝評估',
            rightKneeCheck: '右膝評估',
            leg: '腿型',
            leftLeg: '左腿：',
            rightLeg: '右腿：',
        },
        // 定义解读
        explain: [
            {
                title: '頭前引',
                msg: '左側面耳朵點與脖子中心連線和側面中位線的夾角',
            },
            {
                title: '頭側歪',
                msg: '正面頭部中點與脖子中心連線和正面中位線的夾角',
            },
            {
                title: '左圓肩',
                msg: '背部左側最高點連線和肩部切線的夾角',
            },
            {
                title: '右圓肩',
                msg: '背部右側最高點連線和肩部切線的夾角',
            },
            {
                title: '高低肩',
                msg: '背面左右肩峰點垂直方向的距離',
            },
            {
                title: '骨盆前/後移',
                msg: '左側面脖子中心點、髖骨點、腳踝三點連線的夾角',
            },
            {
                title: '左膝評估',
                msg: '左側面髖骨點、膝關節、腳踝點三點連線的夾角',
            },
            {
                title: '右膝評估',
                msg: '右側面髖骨點、膝關節、腳踝點三點連線的夾角',
            },
            {
                title: '腿型',
                msg: '左右腿正面髖骨骼點、膝關節、腳踝點連線的夾角',
            },
            {
                title: '骨盆前/後傾斜',
                msg: '由左右髂前上棘點及恥骨聯合所形成的平面，與地面垂直線之間的夾角。'
            },
            {
                title: '下肢長度不等',
                msg: '從背部比較，左右兩側臀線最低點離地高度的差距。'
            }
        ],
        exception: [
            {
                title: '偏左',
                abnormal: '',
            },
            {
                title: '偏右',
                abnormal: '',
            },
            {
                title: '左高',
                abnormal: '',
            },
            {
                title: '右高',
                abnormal: '',
            },
            {
                title: '骨盆後移',
                abnormal: '',
            },
            {
                title: '骨盆前移',
                abnormal: '',
            },
            {
                title: '左膝超伸',
                abnormal: '',
            },
            {
                title: '左膝前曲',
                abnormal: '',
            },
            {
                title: '右膝超伸',
                abnormal: '',
            },
            {
                title: '右膝前曲',
                abnormal: '',
            },
            {
                title: 'K型腿',
                abnormal: '',
            },
            {
                title: 'D型腿',
                abnormal: '',
            },
            {
                title: 'X型腿',
                abnormal: '',
            },
            {
                title: 'O型腿',
                abnormal: '',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: '耳朵與人體重心線之間的垂直距離',
            },
            {
                msg: '左右耳朵連線與水平線之間的角度',
            },
            {
                msg: '左肩峰位置與重心線的垂直距離',
            },
            {
                msg: '右肩峰位置與重心線的垂直距離',
            },
            {
                msg: '兩側頸部根部與肩峰連線的差值',
            },
            {
                msg: '髖關節與人體重心線之間的垂直距離',
            },
            {
                msg: '矢狀面上，踝關節、左膝關節下方1公分處和髖關節的夾角',
            },
            {
                msg: '矢狀面上，踝關節、右膝關節下方1公分處和髖關節的夾角',
            },
            {
                msg: '冠狀面上，左右髖關節、膝關節及踝關節之間的夾角',
            },
        ],
        item: {
            pelvis: '骨盆前傾',
        },
    },
    // 围度信息
    girth: {
        title: '體圍',
        present: '(本次)',
        noHistory: '無數據',
        tpl: [
            {
                title: '頸圍',
                key: 'neckGirth',
            },
            {
                title: '左上臂圍',
                key: 'leftUpperArmGirth',
            },
            {
                title: '右上臂圍',
                key: 'rightUpperArmGirth',
            },
            {
                title: '胸圍',
                key: 'bustGirth',
            },
            {
                title: '高腰圍',
                key: 'waistGirth',
            },
            {
                title: '中腰圍',
                key: 'midWaistGirth',
            },
            {
                title: '臀圍',
                key: 'hipGirth',
            },
            {
                title: '左大腿圍',
                key: 'leftThighGirth',
            },
            {
                title: '左大腿中部圍',
                key: 'leftMidThighGirth',
            },
            {
                title: '左大腿最小圍',
                key: 'leftMinThighGirth',
            },
            {
                title: '右大腿圍',
                key: 'rightThighGirth',
            },
            {
                title: '右大腿中部圍',
                key: 'rightMidThighGirth',
            },
            {
                title: '右大腿最小圍',
                key: 'rightMinThighGirth',
            },
            {
                title: '左小腿圍',
                key: 'leftCalfGirth',
            },
            {
                title: '右小腿圍',
                key: 'rightCalfGirth',
            },
            {
                title: '低腰圍',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: '肩部功能',
        model: {
            val: '測量值',
            scope: '最大活動位置',
            diff: '對比上次',
        },
        normal: '正常',
        conclusion: '結論',
        analyse: '分析: ',
        suggest: '建議: ',
        cause: '具體原因請找專業人士做進一步篩查。',
    },
    reportTips: {
        title: "確定刪除這份報告嗎？刪除後無法恢復。",
        confirm: "刪除",
        success: "報告已刪除",
        partial: "報告已刪除，部分資料同步失敗，請聯繫管理員",
        failed: "刪除失敗，請稍後重試",
        btnMsg: 'OK',
        alaryTips: '該測量報告已被管理員刪除，即將跳轉下一份報告！',
    },
    saveQr: {
        title: 'Visbody 3D體測報告',
        btnMsg: '長按圖片保存到手機',
        tips: '如發現無法保存，請去【設置】打開相應許可權',
    },
    share: {
        title: '請複製下方的鏈接後分享',
        btnMsg: '複製',
    },
    "waist": {
    "title": "腰腹圍度",
    "hou": "後方",
    "qian": "前方"
  },
  "yao_wei_1": "腰部",
  "yao_bu_fen_shu": "腰部評分",
  "waist_fen": "分",
  "yao_wei": "腰圍",
  "yao_wei_jian_ti_ji": "腰圍間容積",
  "yao_tun_bi": "腰臀比",
  "lun_kuo_fen_xi": "外形分析",
  "bei_bu": "背部",
  "tunbu": "臀部",
  "bei_bu_ti_ji": "背部容積",
  "zheng_chang_fan_wei": "正常範圍：",
  "shang_ci": "上次 ",
  "ben_ci": "本次 ",
  "gupen": {
    "zheng_chang": "正常",
    "qian_qin_yan_chang": "前傾異常",
    "qian_qin_yi": "前傾斜風險",
    "hou_qin_yi": "後傾斜風險",
    "hou_qin_yan_chang": "後傾斜異常",
    "zuo_chang_yan_chang": "左側較長異常",
    "zuo_chang_yi": "左側較長風險",
    "you_chang_yi": "右側較長風險",
    "you_chang_yan_chang": "右側較長異常"
  },
  "gao_yao_xian": "高腰圍",
  "gao_yao_zhong_xian": "高腰中線",
  "gao_yao_xia_xian": "高腰下線",
  "xiao_yao_shang_xian": "低腰上線",
  "xiao_yao_zhong_xian": "低腰中線",
  "xiao_yao_xian": "低腰圍",
  "qv_jian1": "高腰上段",
  "qv_jian2": "高腰下段",
  "qv_jian_zhong": "中腰部",
  "qv_jian3": "低腰上段",
  "qv_jian4": "低腰下段",
  "celiang.failed": "量測未成功，請穿著緊身衣物並保持靜止進行量測",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "頭部前傾或側歪趨勢較明顯，頸椎排列略有偏移，建議留意日常坐姿。",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "頭部前傾或側歪趨勢較明顯，頸椎排列有些偏移，建議進行針對性的姿勢管理與肌力訓練。",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "頭部前傾或側歪趨勢較為顯著，頸椎排列偏移趨勢較為明顯，建議結合專業評估進一步確認，並進行系統性姿勢干預。",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "胸椎排列略有偏移趨勢，建議加強姿態管理。",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "胸椎排列存在一定偏移，可能影響軀幹姿態穩定性，建議進行針對性干預訓練。",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "胸椎排列偏移趨勢較為明顯，軀幹對稱性下降，建議結合專業評估進行系統性姿勢管理。",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "腰椎排列略有偏移趨勢，當前整體姿態仍保持相對平衡，建議加強核心穩定訓練。",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "腰椎排列存在一定偏移，姿態穩定性可能受到影響，建議進行針對性調整訓練。",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "腰椎排列偏移趨勢較為明顯，建議結合專業評估並制定系統性姿勢改善方案。",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "肩胛提肌、胸鎖乳突肌及斜方肌上束<i class=\"IRed\">參與度偏高</i>，頸深屈肌<i class=\"IBlue\">參與度相對不足</i>。建議加強頸部穩定與頸深屈肌訓練，並配合肩頸放鬆練習。",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "左側胸鎖乳突肌與後角斜角肌<i class=\"IRed\">參與度偏高</i>，右側胸鎖乳突肌<i class=\"IBlue\">參與度相對不足</i>。建議進行雙側平衡控制訓練，並配合頸部放鬆練習。",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "右側胸鎖乳突肌<i class=\"IRed\">參與度偏高</i>，左側胸鎖乳突肌與後角斜角肌<i class=\"IBlue\">參與度相對不足</i>。建議進行對稱性穩定訓練，並配合頸部放鬆練習。",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "左側斜方肌上束<i class=\"IRed\">參與度偏高</i>，中下束<i class=\"IBlue\">參與度相對不足</i>。建議加強斜方肌中下束控制訓練，並配合上束放鬆練習。",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "髖內旋肌群與內收肌群<i class=\"IRed\">參與度偏高</i>，臀中肌<i class=\"IBlue\">參與度相對不足</i>。建議加強臀中肌穩定訓練，並適度拉伸內收與內旋肌群。",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "臀中肌與梨狀肌<i class=\"IRed\">參與度偏高</i>，髖內收肌群、內旋肌群及膝外側副韌帶穩定<i class=\"IBlue\">參與度相對不足</i>。建議進行下肢整體穩定訓練，並配合臀部放鬆練習。",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "臀中肌與梨狀肌<i class=\"IRed\">參與度偏高</i>，單側髖內收肌群、內旋肌群及膝外側副韌帶穩定<i class=\"IBlue\">參與度相對不足</i>。建議加強雙側均衡訓練，避免單側過度使用。",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "左側腘繩肌與膕肌<i class=\"IRed\">參與度偏高</i>，股四頭肌與比目魚肌<i class=\"IBlue\">參與度相對不足</i>。建議加強股四頭肌與比目魚肌訓練，並適度拉伸腘繩肌與膕肌。",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "左側股四頭肌<i class=\"IRed\">參與度偏高</i>，臀大肌與腘繩肌<i class=\"IBlue\">參與度相對不足</i>。建議加強臀部主導訓練與後側鏈協同訓練，並適度拉伸股四頭肌。",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "右側腘繩肌與膕肌<i class=\"IRed\">參與度偏高</i>，股四頭肌與比目魚肌<i class=\"IBlue\">參與度相對不足</i>。建議加強股四頭肌與比目魚肌訓練，並適度拉伸腘繩肌與膕肌。",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "右側股四頭肌<i class=\"IRed\">參與度偏高</i>，臀大肌與腘繩肌<i class=\"IBlue\">參與度相對不足</i>。建議加強臀部主導訓練與後側鏈協同訓練，並適度拉伸股四頭肌。",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "脊柱結構存在輕微偏離，建議關注日常姿勢並加強核心肌群訓練",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "脊柱結構存在一定偏離，建議結合專業指導進行針對性訓練與改善",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "右側斜方肌上束<i class=\"IRed\">參與度偏高</i>，中下束<i class=\"IBlue\">參與度相對不足</i>。建議進行中下束穩定訓練，並配合上束放鬆練習。",
    ...zhLocale,
    ...agrEn,
  "neckReport": {
  "title": "頸部功能",
  "conclusion": "頸部功能評估",
  "loading": "報告合成中，請稍候",
  "failed": "報告合成失敗",
  "analysis": "分析",
  "suggestion": "建議",
  "suggestionText": "找專業人士進一步篩查及治療原因"
}
}
